import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { ContactForm, PageHeader, SettingsLayout } from "@/components"
import { api } from "../system/api.js"

export default function SettingsContact() {
	const navigate = useNavigate()
	const [message, setMessage] = useState("")
	const [processing, setProcessing] = useState(false)
	const [error, setError] = useState("")
	const [sent, setSent] = useState(false)

	const handleChange = (next) => {
		setMessage(next)
		if (error) setError("")
	}

	const handleSubmit = async (value) => {
		if (processing) return
		setProcessing(true)
		setError("")
		try {
			await api("message/new", { message: value })
			setMessage("")
			setSent(true)
		} catch {
			setError("An error occurred. Please try again.")
		} finally {
			setProcessing(false)
		}
	}

	return (
		<SettingsLayout onBack={() => navigate(-1)}>
			<div className="max-w-lg">
				<PageHeader
					title="Contact Us"
					description="Have a question or need help? We're here for you."
				/>
				<ContactForm
					value={message}
					sent={sent}
					onChange={handleChange}
					onSubmit={handleSubmit}
				/>
				{error && (
					<p className="text-caption text-danger mt-3">{error}</p>
				)}
			</div>
		</SettingsLayout>
	)
}
